export const FETCH_ALL_RATES_REQUEST = 'FETCH_ALL_RATES_REQUEST';
export const FETCH_ALL_RATES_SUCCESS = 'FETCH_ALL_RATES_SUCCESS';
export const FETCH_ALL_RATES_FAILURE = 'FETCH_ALL_RATES_FAILURE';
